import { render, staticRenderFns } from "./blog.vue?vue&type=template&id=c10146a8&scoped=true"
import script from "./blog.vue?vue&type=script&lang=js"
export * from "./blog.vue?vue&type=script&lang=js"
import style0 from "./blog.vue?vue&type=style&index=0&id=c10146a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10146a8",
  null
  
)

export default component.exports